import axios from 'axios';

let defaultZoomLevel = 16;
let modalActiveClass = 'localAreaMap__modal--active';

const styles = [
  {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#e9e9e9"
          },
          {
              "lightness": 17
          }
      ]
  },
  {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#f5f5f5"
          },
          {
              "lightness": 20
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#ffffff"
          },
          {
              "lightness": 17
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
          {
              "color": "#ffffff"
          },
          {
              "lightness": 29
          },
          {
              "weight": 0.2
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#ffffff"
          },
          {
              "lightness": 18
          }
      ]
  },
  {
      "featureType": "road.local",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#ffffff"
          },
          {
              "lightness": 16
          }
      ]
  },
  {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#f5f5f5"
          },
          {
              "lightness": 21
          }
      ]
  },
  {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#dedede"
          },
          {
              "lightness": 21
          }
      ]
  },
  {
      "elementType": "labels.text.stroke",
      "stylers": [
          {
              "visibility": "on"
          },
          {
              "color": "#ffffff"
          },
          {
              "lightness": 16
          }
      ]
  },
  {
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "saturation": 36
          },
          {
              "color": "#333333"
          },
          {
              "lightness": 40
          }
      ]
  },
  {
      "elementType": "labels.icon",
      "stylers": [
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "transit",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#f2f2f2"
          },
          {
              "lightness": 19
          }
      ]
  },
  {
      "featureType": "administrative",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#fefefe"
          },
          {
              "lightness": 20
          }
      ]
  },
  {
      "featureType": "administrative",
      "elementType": "geometry.stroke",
      "stylers": [
          {
              "color": "#fefefe"
          },
          {
              "lightness": 17
          },
          {
              "weight": 1.2
          }
      ]
  }
];

const LocalAreaMap = () => {

  let map = new google.maps.Map(document.getElementById("map"), {
      zoom: 8,
      center: {
          lat: 51.507351, lng: -0.127758
      },
      styles: styles,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM
        }
  });

  axios.get(website_url + '/wp-json/adapt/development-map-data?id=' + document.getElementById('js-development-id').value)
  .then(function (response) {

      response.data = JSON.parse(response.data);

      if ( response.data.latitude != '' ) {

          let homeStyle = response.data.developmentIcon;
          let foodIconStyle = response.data.foodIcon;
          let thingsIconStyle = response.data.thingsIcon;
          let shoppingIconStyle = response.data.shoppingIcon;
          let schoolsStyle = response.data.schoolsIcon;
          let transportStyle = response.data.transportIcon;
          let healthStyle = response.data.healthIcon;

          let developmentLocation = {
              lat: parseFloat(response.data.latitude),
              lng: parseFloat(response.data.longitude)
          };

          new google.maps.Marker({
              position: developmentLocation,
              map: map,
              icon: homeStyle
          });

          map.setCenter(developmentLocation);
          map.setZoom(defaultZoomLevel);
          let markers = response.data.markers;

          if (markers.length > 0) {

              let bounds = new google.maps.LatLngBounds();

              bounds.extend(developmentLocation);

              document.onkeydown = function(event) {
                if (event.keyCode === 27) {
                        let modal = document.querySelector('.localAreaMap__modal');
                        modal.classList.contains(modalActiveClass) ? document.querySelector('.localAreaMap__modal--active').classList.remove('localAreaMap__modal--active') : null;
                    }
               };

            Array.prototype.forEach.call(markers, (marker) => {

                let iconStyle;

                if (marker.category === 'food') {
                    iconStyle = foodIconStyle;
                } else if (marker.category === 'shopping') {
                    iconStyle = shoppingIconStyle;
                } else if (marker.category === 'things') {
                    iconStyle = thingsIconStyle;
                } else if (marker.category === 'education' || marker.category === 'schools') {
                    iconStyle = schoolsStyle;
                } else if (marker.category === 'transport') {
                    iconStyle = transportStyle;
                } else if (marker.category === 'health') {
                    iconStyle = healthStyle;
                }

                let markerLocation = {
                    lat: parseFloat(marker.latitude),
                    lng: parseFloat(marker.longitude)
                };

                let markerIcon = new google.maps.Marker({
                    position: markerLocation,
                    map: map,
                    title: marker.name,
                    image: '',
                    icon: iconStyle
                });

                markerIcon.addListener('click', () => {

                let modal = document.querySelector('.localAreaMap__modal');
                let modalImage = document.querySelector('.localAreaMap__modalImage');
                let modalTitle = document.querySelector('.localAreaMap__modalTitle');
                let modalText = document.querySelector('.localAreaMap__modalDesc');

                let { image, name, description } = marker;

                modal.classList.remove(modalActiveClass);

                const returnContent = () => {
                    modalImage.style.backgroundImage = `url(${image})`;
                    modalTitle.innerHTML = name;
                    modalText.innerHTML = description;
                    modal.classList.add(modalActiveClass);
                }

                setTimeout(returnContent, 300);

                map.setZoom(16);
                map.setCenter(markerIcon.getPosition());

                });

                bounds.extend(markerLocation);

            });

            map.fitBounds(bounds);

          }
      }
  })
  .catch(function (error) {

  });

}

export default LocalAreaMap;


// WEBPACK FOOTER //
// ./src/js/app/components/LocalAreaMap.js